/**
 * FAQ Content Data
 *
 * Extracted from components/contact/faq-section.tsx for CMS readiness.
 * These items cover common questions about interior design services.
 *
 * @see Story 3-6: Static Content Extraction for CMS
 */

export type FAQItem = {
	/** Unique identifier for the FAQ item */
	id: string;
	/** The question being asked */
	question: string;
	/** Detailed answer to the question */
	answer: string;
};

/**
 * FAQ items for the contact page
 */
export const FAQ_ITEMS: FAQItem[] = [
	{
		id: "process",
		question: "What is your design process?",
		answer:
			"Our design process begins with an initial consultation to understand your vision, lifestyle, and requirements. We then develop concept boards and 3D visualizations, followed by detailed design development, material selection, and project documentation. Throughout the process, we maintain close communication and provide regular updates to ensure your complete satisfaction.",
	},
	{
		id: "timeline",
		question: "How long does a typical project take?",
		answer:
			"Project timelines vary based on scope and complexity. A consultation typically takes 1-2 weeks, while a full residential design project ranges from 8-16 weeks. Commercial and hospitality projects may take 3-6 months or longer depending on size. During our initial consultation, we'll provide a detailed timeline tailored to your specific project.",
	},
	{
		id: "consultation",
		question: "What is included in a consultation?",
		answer:
			"A consultation includes a comprehensive site visit, discussion of your design goals and preferences, initial space assessment, and preliminary recommendations. You'll receive a summary document with our observations, suggested design direction, and estimated budget ranges for the proposed scope of work.",
	},
	{
		id: "budget",
		question: "Do you work with specific budgets?",
		answer:
			"Yes, we work with a range of budgets and tailor our services accordingly. During the initial consultation, we discuss your budget expectations and help you understand what's achievable. We're transparent about costs and provide detailed quotes before beginning any work, ensuring there are no surprises.",
	},
	{
		id: "revisions",
		question: "How many revisions are included?",
		answer:
			"Our standard packages include two rounds of revisions at each major milestone (concept, design development, and final documentation). Additional revisions can be accommodated at an hourly rate. We find that our collaborative process typically resolves most feedback within the included revisions.",
	},
	{
		id: "payments",
		question: "What payment methods do you accept?",
		answer:
			"We accept bank transfers, credit cards, and certified checks. Projects typically require a 50% deposit to begin, with remaining payments structured around project milestones. For larger projects, we can arrange customized payment schedules. All payment terms are clearly outlined in our service agreement.",
	},
];

/**
 * FAQ section metadata
 */
export const FAQ_SECTION = {
	title: "Frequently Asked Questions",
	description:
		"Find answers to common questions about our interior design services.",
} as const;
